module.exports = __webpack_public_path__ + "static/img/start.2d8ca2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Magazine/start.jpg
// module id = REYE
// module chunks = 1